let instance = null;
/**
 * Static Id Class used to init debug on Orch Load
 *  - One time instantiation
 *  - Modifying debug will prevent over-riding initial value
 */
class StaticIdSingleton {
  /**
   * Default constructor
   * - Multiple instantiation will provide same instance(First time instance)
   */
  constructor() {
    if (!instance) {
      instance = this; // eslint-disable-line consistent-this
    }
    this._debug = null;
    return instance;
  }

  /**
   * Returns debug
   * @returns {string} _debug
   */
  get debug() {
    return this._debug;
  }

  /**
   * Set debug and prevents recurring changes to inital value
   * @param {string} value
   */
  set debug(value) {
    if (!this._debug) {
      this._debug = value;
    }
  }
}

export default new StaticIdSingleton();
